import { DynamicRow } from "./dynamic-row.model";
import { DynamicTabPanel } from "./dynamic-tab-panel.model";

export class DynamicTabView<T> extends DynamicRow<T> {

    tabs?: Array<DynamicTabPanel<T>>;

    constructor(source: Partial<DynamicTabView<T>>) {
        super(source);
        this.type = "tabview";
        Object.assign(this, source);

    }

}